import React from 'react';

export default function Footer() {
    return(
        <div style={{
        position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            textAlign: 'center',
        padding: '10px 0',
            paddingBottom: '10px',
        }}>
            <p style={{
                color: 'white', 
                fontWeight: 'bold',
                margin: 0
            }}>
                © 2025 Grid Area. Alle rechten voorbehouden.
            </p>
        </div>
    );
}